import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import elevatorHeroImg from "../../assets/images/elevatorHeroImg.png";

const HeroSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Determine if we're on mobile
  const isMobile = windowWidth <= 820;
  const isTablet = windowWidth <= 1024 && windowWidth > 820;
  const isSmallMobile = windowWidth < 480;
  const isLaptop = windowWidth <= 1440 && windowWidth > 1024;

  useEffect(() => {
    // Trigger animations after component mounts
    setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    // Handle window resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        ...styles.heroContainer,
        minHeight: isLaptop ? "90vh" : "100vh", // Reduce height on laptops
      }}
    >
      {/* Full background image */}
      <div
        style={{
          ...styles.backgroundImageContainer,
          opacity: isLoaded ? 1 : 0,
        }}
      >
        <img
          src={elevatorHeroImg}
          alt="Premium Elevator"
          style={{
            ...styles.backgroundImage,
            transform: isLoaded ? "scale(1)" : "scale(1.1)",
          }}
        />
        {/* Darker overlay for better text readability */}
        <div style={styles.backgroundOverlay}></div>
      </div>

      {/* Content centered over the background */}
      <div
        style={{
          ...styles.contentContainer,
          opacity: isLoaded ? 1 : 0,
          transform: isLoaded ? "translateY(0)" : "translateY(30px)",
          padding: isLaptop ? "60px 0" : "0",
        }}
      >
        <div
          style={{
            ...styles.contentWrapper,
            maxWidth: isMobile ? "95%" : isLaptop ? "90%" : "1200px",
            padding: isMobile
              ? "30px 20px"
              : isLaptop
              ? "20px 30px"
              : "30px 40px",
          }}
        >
          {/* Professional accent line */}
          <div style={styles.accentLine}></div>

          {/* <div style={styles.badge}>
            <span style={styles.badgeIcon}>★</span>
            Trusted Since 2010
          </div> */}

          <h1
            style={{
              ...styles.tagline,
              fontSize: isSmallMobile
                ? "2.5rem"
                : isMobile
                ? "3.2rem"
                : isTablet
                ? "3.8rem"
                : isLaptop
                ? "4.2rem"
                : "5rem",
              letterSpacing: "-1px",
              maxWidth: isMobile ? "95%" : "80%",
              marginBottom: isLaptop ? "15px" : "25px",
            }}
          >
            Elevating <span style={styles.highlight}>Excellence</span>
          </h1>

          <h2
            style={{
              ...styles.subTagline,
              fontSize: isSmallMobile
                ? "1.1rem"
                : isMobile
                ? "1.2rem"
                : isLaptop
                ? "1.3rem"
                : "1.5rem",
              maxWidth: isMobile ? "95%" : isLaptop ? "85%" : "70%",
              margin: isMobile
                ? "0 auto 35px auto"
                : isLaptop
                ? "0 auto 35px auto"
                : "0 auto 50px auto",
            }}
          >
            Premium elevator solutions designed for safety, efficiency, and
            aesthetic perfection. Trusted by architects and builders worldwide.
          </h2>

          {/* Divider line */}
          <div
            style={{
              ...styles.divider,
              marginBottom: isLaptop ? "25px" : "40px",
            }}
          ></div>

          {/* Feature list in horizontal layout for larger screens */}
          <ul
            style={{
              ...styles.featuresList,
              display: isSmallMobile ? "none" : "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: "center",
              justifyContent: "space-around",
              marginBottom: isMobile ? "30px" : isLaptop ? "35px" : "60px",
              width: "100%",
              maxWidth: isMobile ? "600px" : "100%",
            }}
          >
            {[
              "Advanced Safety with Intelligent Monitoring",
              "Energy-Efficient Green Technology",
              "24/7 Responsive Support & Maintenance",
            ].map((feature, index) => (
              <li
                key={index}
                style={{
                  ...styles.featureItem,
                  opacity: isLoaded ? 1 : 0,
                  transform: isLoaded ? "translateY(0)" : "translateY(20px)",
                  transitionDelay: `${0.3 + index * 0.2}s`,
                  fontSize: isMobile ? "1rem" : isLaptop ? "1rem" : "1.1rem",
                  marginBottom: isMobile ? "12px" : "0",
                  marginRight: !isMobile && index < 2 ? "20px" : "0",
                  width: isMobile ? "auto" : "30%",
                  textAlign: isMobile ? "left" : "center",
                  flexDirection: isMobile ? "row" : "column",
                  padding: isMobile ? "0" : isLaptop ? "0 10px" : "0 15px",
                }}
              >
                <div
                  style={{
                    ...styles.checkmarkCircle,
                    marginRight: isMobile ? "15px" : "0",
                    marginBottom: isMobile ? "0" : "12px",
                  }}
                >
                  <span style={styles.checkmark}>✓</span>
                </div>
                {feature}
              </li>
            ))}
          </ul>

          {/* Button Container */}
          <div
            style={{
              ...styles.buttonContainer,
              opacity: isLoaded ? 1 : 0,
              transform: isLoaded ? "translateY(0)" : "translateY(20px)",
              transitionDelay: "0.9s",
              flexDirection: isSmallMobile ? "column" : "row",
              gap: isSmallMobile ? "15px" : isLaptop ? "20px" : "30px",
              marginTop: isLaptop ? "5px" : "10px",
            }}
          >
            <Link
              to="/products"
              style={{
                textDecoration: "none",
                width: isSmallMobile ? "100%" : "auto",
              }}
            >
              <button
                style={{
                  ...styles.ctaButton,
                  padding: isMobile
                    ? "14px 28px"
                    : isLaptop
                    ? "16px 35px"
                    : "18px 42px",
                  fontSize: isSmallMobile
                    ? "0.95rem"
                    : isMobile
                    ? "1rem"
                    : isLaptop
                    ? "1.05rem"
                    : "1.15rem",
                  width: isSmallMobile ? "100%" : "auto",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-5px)";
                  e.target.style.boxShadow =
                    "0 10px 25px rgba(22, 59, 162, 0.45)";
                  e.target.style.backgroundColor = "#0f2875";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow =
                    "0 4px 10px rgba(22, 59, 162, 0.3)";
                  e.target.style.backgroundColor = "#163ba2";
                }}
              >
                Customize Your Elevator
                <span style={styles.buttonArrow}>→</span>
              </button>
            </Link>
            <Link
              to="/contact"
              style={{
                textDecoration: "none",
                width: isSmallMobile ? "100%" : "auto",
              }}
            >
              <button
                style={{
                  ...styles.secondaryButton,
                  padding: isMobile
                    ? "13px 24px"
                    : isLaptop
                    ? "15px 30px"
                    : "17px 38px",
                  fontSize: isSmallMobile
                    ? "0.95rem"
                    : isMobile
                    ? "1rem"
                    : isLaptop
                    ? "1.05rem"
                    : "1.15rem",
                  width: isSmallMobile ? "100%" : "auto",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "rgba(255, 255, 255, 0.25)";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                Contact Us
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Enhanced decorative elements - positioned further apart */}
      {!isMobile && (
        <>
          <div
            style={{
              ...styles.decorativeDot,
              top: "18%",
              right: "8%",
              opacity: isLoaded ? 0.5 : 0,
              transitionDelay: "1.2s",
              width: isLaptop ? "140px" : "180px",
              height: isLaptop ? "140px" : "180px",
            }}
          ></div>
          <div
            style={{
              ...styles.decorativeDot,
              bottom: "18%",
              left: "6%",
              opacity: isLoaded ? 0.4 : 0,
              transitionDelay: "1.4s",
              width: isLaptop ? "120px" : "150px",
              height: isLaptop ? "120px" : "150px",
            }}
          ></div>
          <div
            style={{
              ...styles.decorativeDot,
              top: "50%",
              left: "15%",
              opacity: isLoaded ? 0.3 : 0,
              transitionDelay: "1.6s",
              width: isLaptop ? "80px" : "100px",
              height: isLaptop ? "80px" : "100px",
            }}
          ></div>
        </>
      )}
    </div>
  );
};

const styles = {
  heroContainer: {
    position: "relative",
    height: "100vh",
    width: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#0a0f1e",
  },
  backgroundImageContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1,
    transition: "opacity 0.8s ease",
  },
  backgroundImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center center",
    transition: "transform 2s ease-out",
    filter: "brightness(0.6) contrast(1.2) saturate(1) blur(2px)",
  },
  backgroundOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(10, 15, 30, 0.75)",
    zIndex: 2,
  },
  contentContainer: {
    position: "relative",
    zIndex: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "90vw",
    transition: "opacity 1.2s ease, transform 1.2s ease",
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    position: "relative",
  },
  accentLine: {
    position: "absolute",
    top: "0",
    width: "120px",
    height: "4px",
    background:
      "linear-gradient(to right, rgba(77, 159, 255, 0), #4d9fff, rgba(77, 159, 255, 0))",
    marginBottom: "30px",
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "8px 18px",
    borderRadius: "20px",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    color: "#ffffff",
    fontSize: "0.95rem",
    fontWeight: "600",
    marginBottom: "28px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    boxShadow: "0 3px 15px rgba(0, 0, 0, 0.2)",
    letterSpacing: "0.8px",
  },
  badgeIcon: {
    marginRight: "8px",
    fontSize: "0.85rem",
    opacity: 0.9,
    color: "#FFD700",
  },
  tagline: {
    lineHeight: "1.05",
    marginBottom: "25px",
    fontWeight: "900",
    color: "#ffffff",
    position: "relative",
    textShadow: "0 2px 15px rgba(0,0,0,0.4)",
    textTransform: "uppercase",
    letterSpacing: "-0.5px",
  },
  highlight: {
    color: "#4d9fff",
    position: "relative",
    display: "inline-block",
    textShadow: "0 0 25px rgba(77, 159, 255, 0.7)",
    fontStyle: "italic",
  },
  subTagline: {
    fontWeight: "400",
    color: "rgba(255, 255, 255, 0.95)",
    lineHeight: "1.6",
    textShadow: "0 2px 8px rgba(0,0,0,0.5)",
    letterSpacing: "0.3px",
  },
  divider: {
    width: "180px",
    height: "1px",
    background:
      "linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0.7), rgba(255,255,255,0))",
    marginBottom: "40px",
  },
  featuresList: {
    listStyle: "none",
    padding: 0,
    marginBottom: "40px",
  },
  featureItem: {
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    transition: "opacity 0.8s ease, transform 0.8s ease",
    color: "#ffffff",
    fontWeight: "500",
    textShadow: "0 2px 8px rgba(0,0,0,0.4)",
    letterSpacing: "0.2px",
  },
  checkmarkCircle: {
    width: "26px",
    height: "26px",
    borderRadius: "50%",
    backgroundColor: "rgba(77, 159, 255, 0.25)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    border: "2px solid rgba(77, 159, 255, 0.5)",
    boxShadow: "0 0 15px rgba(77, 159, 255, 0.3)",
  },
  checkmark: {
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "14px",
    textShadow: "0 1px 2px rgba(0,0,0,0.3)",
  },
  buttonContainer: {
    display: "flex",
    transition: "opacity 0.8s ease, transform 0.8s ease",
    justifyContent: "center",
    marginTop: "10px",
  },
  ctaButton: {
    backgroundColor: "#163ba2",
    color: "#fff",
    border: "none",
    borderRadius: "30px",
    cursor: "pointer",
    fontWeight: "600",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.4)",
    transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  },
  buttonArrow: {
    marginLeft: "8px",
    transition: "transform 0.3s ease",
    display: "inline-block",
  },
  secondaryButton: {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    color: "#ffffff",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    borderRadius: "30px",
    cursor: "pointer",
    fontWeight: "500",
    transition: "all 0.3s ease",
    letterSpacing: "0.5px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
    textTransform: "uppercase",
  },
  decorativeDot: {
    position: "absolute",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%)",
    zIndex: 3,
    transition: "opacity 1s ease",
  },
};

export default HeroSection;
